import { render, staticRenderFns } from "./consent-banks.vue?vue&type=template&id=2cfe9ced&scoped=true"
import script from "./consent-banks.vue?vue&type=script&lang=js"
export * from "./consent-banks.vue?vue&type=script&lang=js"
import style0 from "./consent-banks.vue?vue&type=style&index=0&id=2cfe9ced&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfe9ced",
  null
  
)

export default component.exports